import { render, staticRenderFns } from "./SurveyResultAttribute.vue?vue&type=template&id=6b36ca60&scoped=true"
import script from "./SurveyResultAttribute.vue?vue&type=script&lang=ts"
export * from "./SurveyResultAttribute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36ca60",
  null
  
)

export default component.exports